import { render, staticRenderFns } from "./contact-form.vue?vue&type=template&id=2f569d6b&scoped=true&"
import script from "./contact-form.vue?vue&type=script&lang=js&"
export * from "./contact-form.vue?vue&type=script&lang=js&"
import style0 from "./contact-form.vue?vue&type=style&index=0&id=2f569d6b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f569d6b",
  null
  
)

export default component.exports